const parsUrlForPay = (url: string): string => {
  return url.replace(/=/ig, ': ').replace(/&/ig, ' ')
}
export default parsUrlForPay
